import { ErrorDictionary } from "../errorDictionary";
import { formatError } from "../_utils/formatError";

export type ErrorCode = keyof typeof ErrorDictionary;

export class HubError extends Error {
  public constructor(
    errorCode: string,
    message: string,
    detailedMessage: string,
    timestamp: string
  ) {
    super(message);
    this.errorCode = errorCode;
    this.message = message;
    this.detailedMessage = detailedMessage;
    this.timestamp = timestamp;
  }

  public errorCode: string;
  public message: string;
  public detailedMessage: string;
  public timestamp: string;

  public static async throwAsync(response: Response): Promise<never> {
    const json = await response.json();

    const errorCode = json["errorCode"];

    //TODO Уйти от использования двух ключей, оставить один, message
    let message = "";
    let detailedMessage = "";

    if(errorCode in ErrorDictionary) {
      message = formatError(ErrorDictionary[errorCode as ErrorCode].message, json["args"]);
    }

    const timestamp = json["timestamp"];

    throw new HubError(errorCode, message, detailedMessage, timestamp);
  }
}
